/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class AccountColonyDraftCollection extends Logic
{
  getInitialColonyDrafts ()
  {
    const size = this.object.getSettings().getInitialColonySize();

    return this.object.getColonyDrafts().values().filter(draft => draft.cass.size === size);
  }


};
